var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex mb-2" },
        [
          _c("vSelect", {
            staticStyle: { flex: "1 1 auto" },
            attrs: {
              label: "name",
              options: _vm.availableInventories,
              clearable: false
            },
            model: {
              value: _vm.inventoryToAdd,
              callback: function($$v) {
                _vm.inventoryToAdd = $$v
              },
              expression: "inventoryToAdd"
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-success ml-2",
              staticStyle: { flex: "0 0 auto" },
              on: { click: _vm.addInventory }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("btnAdd")) + "\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.invColumnsConfig,
          rows: _vm.linkedInventories,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.removeInventory(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-dumpster" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }